<template>
  <el-select
    v-model="dataValue"
    placeholder="请选择考试科目"
    @change="onChange">
    <el-option
      v-if="showAll"
      label="全部"
      :value="null"></el-option>
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.subjectName"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'SubjectSelect',
  props: {
    value: { type: [Number, null], default: null },
    showAll: { type: Boolean, default: false }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    dataValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    onChange(e) {
      this.$emit('change', e)
    },
    getList() {
      this.$$examApi.getexamsubjects({ pageNum: 1, pageSize: 100 })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
